export default __webpack_public_path__ + "static/media/both.4cc23534.svg";